const styles = (theme) => ({
    textDivider: {
        marginTop: '20px',
        marginBottom: '20px'
    }
});

export default styles;